import { render, staticRenderFns } from "./textField.vue?vue&type=template&id=56b16b56&"
import script from "./textField.vue?vue&type=script&lang=ts&"
export * from "./textField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports